import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import React, { useEffect, useState } from "react";
import { getAPICall } from "lib/callApi";
import { GET_APP_DETAILED_SETTINGS } from "lib/constants";
import DashboardLayout from "utils/LayoutContainers/DashboardLayout";
import DashboardNavbar from "utils/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import { useLocation, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import useWorkspaceSubscription from "hooks/useWorkspaceSubscription";

const genTabProps = (index) => ({
  id: `kpi-tab-${index}`,
  "aria-controls": `kpi-tabpanel-${index}`,
  key: `kpi-tab-${index}`,
});

function TabPanel(props) {
  const { children, value, index, tab, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== tab.tabId}
      id={`kpi-tabpanel-${index}`}
      aria-labelledby={`kpi-tab-${index}`}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...other}
    >
      {value === tab.tabId && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function Settings({ prebuiltComponents }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const { refetchSubscription } = useWorkspaceSubscription();
  const modules = useSelector((state) => state.modules.enabledModules);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(new URLSearchParams(searchParams).get("selectedTab"));
  const [tabs, setTabs] = useState([]);

  const getDetailedSettingsCb = async () => {
    const result = await getAPICall(GET_APP_DETAILED_SETTINGS, true);
    if (result?.data?.tabs) {
      setTabs(result.data.tabs);
      setLoading(false);
    }
  };

  useEffect(() => {
    getDetailedSettingsCb();
    refetchSubscription();
  }, [modules]);

  useEffect(() => {
    const isKpiRoute = location?.pathname?.startsWith("/kpi");
    setActiveTab(isKpiRoute ? "kpi" : new URLSearchParams(location.search).get("selectedTab"));
  }, [location]);

  const handleChange = (e, newTabIndex) => {
    setSearchParams({ selectedTab: tabs[newTabIndex].tabId });
    setActiveTab(tabs[newTabIndex].tabId);
  };

  if (loading) return <div>Loading</div>;

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {tabs.length && (
        <Box sx={{ width: "100%" }}>
          <MDBox minWidth={{ xs: "22rem", md: "25rem" }} sx={{ width: "25%" }}>
            <Tabs
              value={tabs.findIndex((tab) => tab.tabId === activeTab)}
              onChange={handleChange}
              aria-label="Settings page tabs"
            >
              {tabs.map((tab, index) => (
                <Tab label={tab.tabLabel} {...genTabProps(index)} />
              ))}
            </Tabs>
          </MDBox>
          {tabs.map((tab, index) => {
            const ComponentToRender =
              prebuiltComponents[
                tab.tabId === "integrations" ? "IntegrationSection" : tab.tabItems[0].component
              ];
            return (
              <TabPanel value={activeTab} tab={tab} index={index} key={`tab-content-${tab.tabId}`}>
                <ComponentToRender
                  key={`${tab.tabId}-component`}
                  tabId={tab.tabId}
                  tabItems={tab.tabItems}
                />
              </TabPanel>
            );
          })}
        </Box>
      )}
    </DashboardLayout>
  );
}

export default Settings;
